// extracted by mini-css-extract-plugin
module.exports = {"icon":"LinkBlock_icon__21So0"};